module.exports = __webpack_public_path__ + "resources/de6d3b4350d95e575bf730434febc000.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/crisis.png
// module id = 206
// module chunks = 0